import { api } from "@/api/axios.ts";
import {
  ApiAnalyticsRecruitingClosingTimeReport,
  ApiAnalyticsRecruitingDisqualificationReasonsReport,
  ApiAnalyticsRecruitingFilter,
  ApiAnalyticsRecruitingSourceEfficiencyReport,
  ApiAnalyticsRecruitingStageFlowReport,
} from "@/types/analytics/analytics.recruiting.types.ts";

export const recruiting = {
  stageFlowReport: function (filter: ApiAnalyticsRecruitingFilter, signal?: AbortSignal) {
    return api.post<ApiAnalyticsRecruitingStageFlowReport>(
      `/api/v1/analytics/recruiting/stage-flow-report`,
      filter,
      signal
    );
  },
  stageFlowReportExport: function (filter: ApiAnalyticsRecruitingFilter) {
    return api.post<BlobPart>(`/api/v1/analytics/recruiting/stage-flow-report`, filter, undefined, {
      responseType: "blob",
    });
  },
  sourceEfficiencyReport: function (filter: ApiAnalyticsRecruitingFilter, signal?: AbortSignal) {
    return api.post<ApiAnalyticsRecruitingSourceEfficiencyReport>(
      `/api/v1/analytics/recruiting/source-efficiency-report`,
      filter,
      signal
    );
  },

  closingTimeReport: (filter: ApiAnalyticsRecruitingFilter, signal?: AbortSignal) => {
    return api.post<ApiAnalyticsRecruitingClosingTimeReport>(
      `/api/v1/analytics/recruiting/closing-time-report`,
      filter,
      signal
    );
  },

  disqualificationReasonsReport: (filter: ApiAnalyticsRecruitingFilter, signal?: AbortSignal) => {
    return api.post<ApiAnalyticsRecruitingDisqualificationReasonsReport>(
      `/api/v1/analytics/recruiting/disqualification-reasons-report`,
      filter,
      signal
    );
  },
};
